import { StoreHistory } from 'src/app/historial/models/manager-content-vehicle-history-drawer.model';
import { HistoryCard } from '../models/content-vehicle-history-drawer.model';
import { formatMessageToastHistory } from '../helpers/format-dates.helper';

export function adaptHistoryCard(data: StoreHistory): HistoryCard {
  return {
    name: data.unit.unitName ?? '',
    imei: data.unit.GNSSIMEI ?? '',
    date: formatMessageToastHistory(data.detailsHistory),
    totalDistance: data.detailsHistory.total_distance_km ?? 0,
    totalTimeOn: data.detailsHistory.duration_ignition_on_s ?? 0,
    totalTimeOff: data.detailsHistory.duration_ignition_off_s ?? 0,
    avgSpeed: data.detailsHistory.avg_speed ?? 0,
    totalStops: data.detailsHistory.stops.length ?? 0,
    totalMovements: data.detailsHistory.movements.length ?? 0,
  };
}
